import { createReducer } from "@reduxjs/toolkit";
import { API_GET_ALL_BOXES, API_GET_ALL_BOXES_FAIL, API_GET_ALL_BOXES_SUCCESS, RESET_BOX, SET_BOX_SUCCESS } from "actions/box";
import { errorHandler, ErrorAction } from "utils/error";

const initialState = {
	list: [],
	focus: null,
	loading: false,
	exists: null,
	box: null,
};

const boxes = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_BOXES]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_BOXES_FAIL]: (state, action) => {
		errorHandler("Box", ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_BOXES_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},

	[SET_BOX_SUCCESS]: (state, action) => {
		state.box = action.payload.data.box;
	},

	[RESET_BOX]: (state, action) => {
		state.box = null;
	},
});

export default boxes;
